export function convertODValidatorToFormikValidator(schema) {
  // TODO:
  // No error at all.
  return function () {
    return {}
  }
}
//# sourceMappingURL=convertODValidatorToFormikValidator.js.map
